import { useTranslation } from 'react-i18next';
import { ChatMessageLimitExceedLabelProps } from './types';

export const ChatMessageLimitExceedLabel = ({ messageSize }: ChatMessageLimitExceedLabelProps) => {
    const { t } = useTranslation();
    return (
        <div className="absolute -bottom-2 left-1/2 min-w-44 bg-warning-light border-2 border-warning rounded-t-lg text-warning text-right pt-1 pb-3 px-2 -translate-x-1/2">
            {t('Chat.MessageInput.CharactersRemaining', { characterAmount: messageSize })}
        </div>
    );
};
